import {Component, Inject} from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {IdexService} from '../../idex.service';

@Component({
   selector: 'app-revert-version',
   templateUrl: 'revert-version.component.html',
   styleUrls: ['revert-version.component.css']
})
export class RevertVersionComponent {
   progress: boolean;
   item: any;
   status: any;
   translate: any;
   toast: any;
   isSite = false;
   currentVersion: any;

   constructor(private dialogRef: MatDialogRef<RevertVersionComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any, private service: IdexService) {
   }

   justRevert(revertButton: MatButton, cancelButton: MatButton) {
      revertButton.disabled = true;
      cancelButton.disabled = true;

      this.isSite = !(this.data.tin === undefined || this.data.tin === '');
      const shared = this.data.items.shared || this.data.shared;
      let alertRevert;
      this.translate.get('alert.revert').subscribe(s => {
         alertRevert = s;
      });
      this.data.service.revert_version(this.item.id,this.currentVersion, this.item.version, shared)
         .subscribe(data => {
            this.data.items.version = data.entry.id;
            this.data.getVersionHistory();
            this.data.data.showdocument.emit();
            this.toast.success(alertRevert);
            this.dialogRef.close();
         }, error => {
            this.dialogRef.close();
         });
   }

   justDelete(deleteButton: MatButton, cancelButton: MatButton) {
      deleteButton.disabled = true;
      cancelButton.disabled = true;
         this.data.service.delete_version(this.item.id, this.item.version)
            .subscribe(data => {
               this.data.getVersionHistory();
               this.translate.get('alert.confirm_delete').subscribe(s => {
                  this.toast.success(s);
               });
               this.dialogRef.close();
            }, error => {
               this.dialogRef.close();
            });
   }
}
